import { useSelector } from 'react-redux';

import { MOBILE_LAYOUT } from 'dpl/constants/query_params';

import { MOBILE_LAYOUTS } from '../utils/constants';

export default function useBreederProfileMobileLayout() {
  const isNewMobileLayout = useSelector(({ queryParams, server }) => {
    return server.isMobileLayout
      ? queryParams[MOBILE_LAYOUT] === MOBILE_LAYOUTS.NEW && server.isPublished
      : null;
  });

  return { isNewMobileLayout };
}
